const accordionBtns = document.querySelectorAll(".accordion-btn"),
      accordionPanels = document.querySelectorAll(".accordion-panel"),
      goUpBtn = document.querySelector(".faq__arrow-up-btn");

export default function init() {

  accordionBtns.forEach((btn, index) => {
    document.addEventListener("click", (btnClick) => {
      if (btnClick.target === btn) {
        let panel = accordionPanels[index];
        panel.classList.toggle("open-accordion");
        // btn.classList.toggle("open-accordion"); 
      }
    })
  });

  goUpBtn.addEventListener('click', () => {
    window.scroll({
      top: 0,
      behaviour: 'smooth'
    })
  });

}
